/**
 * @fileoverview Model for the selection options for a given synced field.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import {OverrideFieldKey, OverrideFieldKeyJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/overridefieldkey';

export class OverrideField {
  /**
   * @param {{
   *  key: OverrideFieldKey,
   *  name: string
   * }} params
   */
  constructor(params) {
    /** @type {OverrideFieldKey} */
    this.key = params.key;
    /** @type {string} */
    this.name = params.name;
  }

  /**
   * @param {!OverrideFieldJson} json
   * @return {!OverrideField}
   */
  static fromJSON(json) {
    return new OverrideField({
      key: OverrideFieldKey.fromJSON(json['key']),
      name: json['name'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  key: OverrideFieldKeyJson,
 *  name: string
 * }}
 */
export let OverrideFieldJson;
